import { createContext, useContext } from 'react';
import type { ListingSide } from '../b2bSideCopy';

// [MCV-1889] Which tab's search the surrounding components read. The Selling tab (SEEKING) is the
// default, so every component outside the Buying tab keeps reading the machine it always did.
const SearchSideContext = createContext<ListingSide>('SEEKING');

export const SearchSideProvider = SearchSideContext.Provider;

export const useSearchSide = (): ListingSide => useContext(SearchSideContext);
